module.exports = __webpack_public_path__ + "img/isbar2.4fd27cd1.png";